/** Copyright (c) Facebook, Inc. and its affiliates.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 *
 */

'use strict';
Object.defineProperty(exports, '__esModule', {value: true});
Object.defineProperty(exports, 'RSocketClient', {
  enumerable: true,
  get: function () {
    return _RSocketClient.default;
  },
});
Object.defineProperty(exports, 'RSocketServer', {
  enumerable: true,
  get: function () {
    return _RSocketServer.default;
  },
});
Object.defineProperty(exports, 'RSocketResumableTransport', {
  enumerable: true,
  get: function () {
    return _RSocketResumableTransport.default;
  },
});
Object.defineProperty(exports, 'WellKnownMimeType', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.default;
  },
});
Object.defineProperty(exports, 'UNPARSEABLE_MIME_TYPE', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.UNPARSEABLE_MIME_TYPE;
  },
});
Object.defineProperty(exports, 'UNKNOWN_RESERVED_MIME_TYPE', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.UNKNOWN_RESERVED_MIME_TYPE;
  },
});
Object.defineProperty(exports, 'APPLICATION_AVRO', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.APPLICATION_AVRO;
  },
});
Object.defineProperty(exports, 'APPLICATION_CBOR', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.APPLICATION_CBOR;
  },
});
Object.defineProperty(exports, 'APPLICATION_GRAPHQL', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.APPLICATION_GRAPHQL;
  },
});
Object.defineProperty(exports, 'APPLICATION_GZIP', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.APPLICATION_GZIP;
  },
});
Object.defineProperty(exports, 'APPLICATION_JAVASCRIPT', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.APPLICATION_JAVASCRIPT;
  },
});
Object.defineProperty(exports, 'APPLICATION_JSON', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.APPLICATION_JSON;
  },
});
Object.defineProperty(exports, 'APPLICATION_OCTET_STREAM', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.APPLICATION_OCTET_STREAM;
  },
});
Object.defineProperty(exports, 'APPLICATION_PDF', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.APPLICATION_PDF;
  },
});
Object.defineProperty(exports, 'APPLICATION_THRIFT', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.APPLICATION_THRIFT;
  },
});
Object.defineProperty(exports, 'APPLICATION_PROTOBUF', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.APPLICATION_PROTOBUF;
  },
});
Object.defineProperty(exports, 'APPLICATION_XML', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.APPLICATION_XML;
  },
});
Object.defineProperty(exports, 'APPLICATION_ZIP', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.APPLICATION_ZIP;
  },
});
Object.defineProperty(exports, 'AUDIO_AAC', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.AUDIO_AAC;
  },
});
Object.defineProperty(exports, 'AUDIO_MP3', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.AUDIO_MP3;
  },
});
Object.defineProperty(exports, 'AUDIO_MP4', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.AUDIO_MP4;
  },
});
Object.defineProperty(exports, 'AUDIO_MPEG3', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.AUDIO_MPEG3;
  },
});
Object.defineProperty(exports, 'AUDIO_MPEG', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.AUDIO_MPEG;
  },
});
Object.defineProperty(exports, 'AUDIO_OGG', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.AUDIO_OGG;
  },
});
Object.defineProperty(exports, 'AUDIO_OPUS', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.AUDIO_OPUS;
  },
});
Object.defineProperty(exports, 'AUDIO_VORBIS', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.AUDIO_VORBIS;
  },
});
Object.defineProperty(exports, 'IMAGE_BMP', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.IMAGE_BMP;
  },
});
Object.defineProperty(exports, 'IMAGE_GIG', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.IMAGE_GIG;
  },
});
Object.defineProperty(exports, 'IMAGE_HEIC_SEQUENCE', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.IMAGE_HEIC_SEQUENCE;
  },
});
Object.defineProperty(exports, 'IMAGE_HEIC', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.IMAGE_HEIC;
  },
});
Object.defineProperty(exports, 'IMAGE_HEIF_SEQUENCE', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.IMAGE_HEIF_SEQUENCE;
  },
});
Object.defineProperty(exports, 'IMAGE_HEIF', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.IMAGE_HEIF;
  },
});
Object.defineProperty(exports, 'IMAGE_JPEG', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.IMAGE_JPEG;
  },
});
Object.defineProperty(exports, 'IMAGE_PNG', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.IMAGE_PNG;
  },
});
Object.defineProperty(exports, 'IMAGE_TIFF', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.IMAGE_TIFF;
  },
});
Object.defineProperty(exports, 'MULTIPART_MIXED', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.MULTIPART_MIXED;
  },
});
Object.defineProperty(exports, 'TEXT_CSS', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.TEXT_CSS;
  },
});
Object.defineProperty(exports, 'TEXT_CSV', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.TEXT_CSV;
  },
});
Object.defineProperty(exports, 'TEXT_HTML', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.TEXT_HTML;
  },
});
Object.defineProperty(exports, 'TEXT_PLAIN', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.TEXT_PLAIN;
  },
});
Object.defineProperty(exports, 'TEXT_XML', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.TEXT_XML;
  },
});
Object.defineProperty(exports, 'VIDEO_H264', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.VIDEO_H264;
  },
});
Object.defineProperty(exports, 'VIDEO_H265', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.VIDEO_H265;
  },
});
Object.defineProperty(exports, 'VIDEO_VP8', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.VIDEO_VP8;
  },
});
Object.defineProperty(exports, 'APPLICATION_HESSIAN', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.APPLICATION_HESSIAN;
  },
});
Object.defineProperty(exports, 'APPLICATION_JAVA_OBJECT', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.APPLICATION_JAVA_OBJECT;
  },
});
Object.defineProperty(exports, 'APPLICATION_CLOUDEVENTS_JSON', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.APPLICATION_CLOUDEVENTS_JSON;
  },
});
Object.defineProperty(exports, 'MESSAGE_RSOCKET_MIMETYPE', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.MESSAGE_RSOCKET_MIMETYPE;
  },
});
Object.defineProperty(exports, 'MESSAGE_RSOCKET_ACCEPT_MIMETYPES', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.MESSAGE_RSOCKET_ACCEPT_MIMETYPES;
  },
});
Object.defineProperty(exports, 'MESSAGE_RSOCKET_AUTHENTICATION', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.MESSAGE_RSOCKET_AUTHENTICATION;
  },
});
Object.defineProperty(exports, 'MESSAGE_RSOCKET_TRACING_ZIPKIN', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.MESSAGE_RSOCKET_TRACING_ZIPKIN;
  },
});
Object.defineProperty(exports, 'MESSAGE_RSOCKET_ROUTING', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.MESSAGE_RSOCKET_ROUTING;
  },
});
Object.defineProperty(exports, 'MESSAGE_RSOCKET_COMPOSITE_METADATA', {
  enumerable: true,
  get: function () {
    return _WellKnownMimeType.MESSAGE_RSOCKET_COMPOSITE_METADATA;
  },
});
Object.defineProperty(exports, 'WellKnownAuthType', {
  enumerable: true,
  get: function () {
    return _WellKnownAuthType.default;
  },
});
Object.defineProperty(exports, 'UNPARSEABLE_AUTH_TYPE', {
  enumerable: true,
  get: function () {
    return _WellKnownAuthType.UNPARSEABLE_AUTH_TYPE;
  },
});
Object.defineProperty(exports, 'UNKNOWN_RESERVED_AUTH_TYPE', {
  enumerable: true,
  get: function () {
    return _WellKnownAuthType.UNKNOWN_RESERVED_AUTH_TYPE;
  },
});
Object.defineProperty(exports, 'SIMPLE', {
  enumerable: true,
  get: function () {
    return _WellKnownAuthType.SIMPLE;
  },
});
Object.defineProperty(exports, 'BEARER', {
  enumerable: true,
  get: function () {
    return _WellKnownAuthType.BEARER;
  },
});
Object.defineProperty(exports, 'CONNECTION_STREAM_ID', {
  enumerable: true,
  get: function () {
    return _RSocketFrame.CONNECTION_STREAM_ID;
  },
});
Object.defineProperty(exports, 'ERROR_CODES', {
  enumerable: true,
  get: function () {
    return _RSocketFrame.ERROR_CODES;
  },
});
Object.defineProperty(exports, 'ERROR_EXPLANATIONS', {
  enumerable: true,
  get: function () {
    return _RSocketFrame.ERROR_EXPLANATIONS;
  },
});
Object.defineProperty(exports, 'FLAGS_MASK', {
  enumerable: true,
  get: function () {
    return _RSocketFrame.FLAGS_MASK;
  },
});
Object.defineProperty(exports, 'FLAGS', {
  enumerable: true,
  get: function () {
    return _RSocketFrame.FLAGS;
  },
});
Object.defineProperty(exports, 'FRAME_TYPE_OFFFSET', {
  enumerable: true,
  get: function () {
    return _RSocketFrame.FRAME_TYPE_OFFFSET;
  },
});
Object.defineProperty(exports, 'FRAME_TYPES', {
  enumerable: true,
  get: function () {
    return _RSocketFrame.FRAME_TYPES;
  },
});
Object.defineProperty(exports, 'MAX_CODE', {
  enumerable: true,
  get: function () {
    return _RSocketFrame.MAX_CODE;
  },
});
Object.defineProperty(exports, 'MAX_KEEPALIVE', {
  enumerable: true,
  get: function () {
    return _RSocketFrame.MAX_KEEPALIVE;
  },
});
Object.defineProperty(exports, 'MAX_LIFETIME', {
  enumerable: true,
  get: function () {
    return _RSocketFrame.MAX_LIFETIME;
  },
});
Object.defineProperty(exports, 'MAX_MIME_LENGTH', {
  enumerable: true,
  get: function () {
    return _RSocketFrame.MAX_MIME_LENGTH;
  },
});
Object.defineProperty(exports, 'MAX_RESUME_LENGTH', {
  enumerable: true,
  get: function () {
    return _RSocketFrame.MAX_RESUME_LENGTH;
  },
});
Object.defineProperty(exports, 'MAX_STREAM_ID', {
  enumerable: true,
  get: function () {
    return _RSocketFrame.MAX_STREAM_ID;
  },
});
Object.defineProperty(exports, 'MAX_VERSION', {
  enumerable: true,
  get: function () {
    return _RSocketFrame.MAX_VERSION;
  },
});
Object.defineProperty(exports, 'createErrorFromFrame', {
  enumerable: true,
  get: function () {
    return _RSocketFrame.createErrorFromFrame;
  },
});
Object.defineProperty(exports, 'getErrorCodeExplanation', {
  enumerable: true,
  get: function () {
    return _RSocketFrame.getErrorCodeExplanation;
  },
});
Object.defineProperty(exports, 'isComplete', {
  enumerable: true,
  get: function () {
    return _RSocketFrame.isComplete;
  },
});
Object.defineProperty(exports, 'isIgnore', {
  enumerable: true,
  get: function () {
    return _RSocketFrame.isIgnore;
  },
});
Object.defineProperty(exports, 'isLease', {
  enumerable: true,
  get: function () {
    return _RSocketFrame.isLease;
  },
});
Object.defineProperty(exports, 'isMetadata', {
  enumerable: true,
  get: function () {
    return _RSocketFrame.isMetadata;
  },
});
Object.defineProperty(exports, 'isNext', {
  enumerable: true,
  get: function () {
    return _RSocketFrame.isNext;
  },
});
Object.defineProperty(exports, 'isRespond', {
  enumerable: true,
  get: function () {
    return _RSocketFrame.isRespond;
  },
});
Object.defineProperty(exports, 'isResumeEnable', {
  enumerable: true,
  get: function () {
    return _RSocketFrame.isResumeEnable;
  },
});
Object.defineProperty(exports, 'printFrame', {
  enumerable: true,
  get: function () {
    return _RSocketFrame.printFrame;
  },
});
Object.defineProperty(exports, 'deserializeFrame', {
  enumerable: true,
  get: function () {
    return _RSocketBinaryFraming.deserializeFrame;
  },
});
Object.defineProperty(exports, 'deserializeFrameWithLength', {
  enumerable: true,
  get: function () {
    return _RSocketBinaryFraming.deserializeFrameWithLength;
  },
});
Object.defineProperty(exports, 'deserializeFrames', {
  enumerable: true,
  get: function () {
    return _RSocketBinaryFraming.deserializeFrames;
  },
});
Object.defineProperty(exports, 'serializeFrame', {
  enumerable: true,
  get: function () {
    return _RSocketBinaryFraming.serializeFrame;
  },
});
Object.defineProperty(exports, 'serializeFrameWithLength', {
  enumerable: true,
  get: function () {
    return _RSocketBinaryFraming.serializeFrameWithLength;
  },
});
Object.defineProperty(exports, 'byteLength', {
  enumerable: true,
  get: function () {
    return _RSocketBufferUtils.byteLength;
  },
});
Object.defineProperty(exports, 'createBuffer', {
  enumerable: true,
  get: function () {
    return _RSocketBufferUtils.createBuffer;
  },
});
Object.defineProperty(exports, 'readUInt24BE', {
  enumerable: true,
  get: function () {
    return _RSocketBufferUtils.readUInt24BE;
  },
});
Object.defineProperty(exports, 'toBuffer', {
  enumerable: true,
  get: function () {
    return _RSocketBufferUtils.toBuffer;
  },
});
Object.defineProperty(exports, 'writeUInt24BE', {
  enumerable: true,
  get: function () {
    return _RSocketBufferUtils.writeUInt24BE;
  },
});
Object.defineProperty(exports, 'BufferEncoders', {
  enumerable: true,
  get: function () {
    return _RSocketEncoding.BufferEncoders;
  },
});
Object.defineProperty(exports, 'BufferEncoder', {
  enumerable: true,
  get: function () {
    return _RSocketEncoding.BufferEncoder;
  },
});
Object.defineProperty(exports, 'Utf8Encoders', {
  enumerable: true,
  get: function () {
    return _RSocketEncoding.Utf8Encoders;
  },
});
Object.defineProperty(exports, 'UTF8Encoder', {
  enumerable: true,
  get: function () {
    return _RSocketEncoding.UTF8Encoder;
  },
});
Object.defineProperty(exports, 'IdentitySerializer', {
  enumerable: true,
  get: function () {
    return _RSocketSerialization.IdentitySerializer;
  },
});
Object.defineProperty(exports, 'IdentitySerializers', {
  enumerable: true,
  get: function () {
    return _RSocketSerialization.IdentitySerializers;
  },
});
Object.defineProperty(exports, 'JsonSerializer', {
  enumerable: true,
  get: function () {
    return _RSocketSerialization.JsonSerializer;
  },
});
Object.defineProperty(exports, 'JsonSerializers', {
  enumerable: true,
  get: function () {
    return _RSocketSerialization.JsonSerializers;
  },
});
Object.defineProperty(exports, 'Leases', {
  enumerable: true,
  get: function () {
    return _RSocketLease.Leases;
  },
});
Object.defineProperty(exports, 'Lease', {
  enumerable: true,
  get: function () {
    return _RSocketLease.Lease;
  },
});
Object.defineProperty(exports, 'CompositeMetadata', {
  enumerable: true,
  get: function () {
    return _CompositeMetadata.CompositeMetadata;
  },
});
Object.defineProperty(exports, 'ReservedMimeTypeEntry', {
  enumerable: true,
  get: function () {
    return _CompositeMetadata.ReservedMimeTypeEntry;
  },
});
Object.defineProperty(exports, 'WellKnownMimeTypeEntry', {
  enumerable: true,
  get: function () {
    return _CompositeMetadata.WellKnownMimeTypeEntry;
  },
});
Object.defineProperty(exports, 'ExplicitMimeTimeEntry', {
  enumerable: true,
  get: function () {
    return _CompositeMetadata.ExplicitMimeTimeEntry;
  },
});
Object.defineProperty(exports, 'encodeAndAddCustomMetadata', {
  enumerable: true,
  get: function () {
    return _CompositeMetadata.encodeAndAddCustomMetadata;
  },
});
Object.defineProperty(exports, 'encodeAndAddWellKnownMetadata', {
  enumerable: true,
  get: function () {
    return _CompositeMetadata.encodeAndAddWellKnownMetadata;
  },
});
Object.defineProperty(exports, 'encodeCompositeMetadata', {
  enumerable: true,
  get: function () {
    return _CompositeMetadata.encodeCompositeMetadata;
  },
});
Object.defineProperty(exports, 'decodeCompositeMetadata', {
  enumerable: true,
  get: function () {
    return _CompositeMetadata.decodeCompositeMetadata;
  },
});
Object.defineProperty(exports, 'RoutingMetadata', {
  enumerable: true,
  get: function () {
    return _RoutingMetadata.RoutingMetadata;
  },
});
Object.defineProperty(exports, 'encodeRoute', {
  enumerable: true,
  get: function () {
    return _RoutingMetadata.encodeRoute;
  },
});
Object.defineProperty(exports, 'encodeRoutes', {
  enumerable: true,
  get: function () {
    return _RoutingMetadata.encodeRoutes;
  },
});
Object.defineProperty(exports, 'decodeRoutes', {
  enumerable: true,
  get: function () {
    return _RoutingMetadata.decodeRoutes;
  },
});
Object.defineProperty(exports, 'encodeSimpleAuthMetadata', {
  enumerable: true,
  get: function () {
    return _AuthMetadata.encodeSimpleAuthMetadata;
  },
});
Object.defineProperty(exports, 'encodeBearerAuthMetadata', {
  enumerable: true,
  get: function () {
    return _AuthMetadata.encodeBearerAuthMetadata;
  },
});
Object.defineProperty(exports, 'encodeWellKnownAuthMetadata', {
  enumerable: true,
  get: function () {
    return _AuthMetadata.encodeWellKnownAuthMetadata;
  },
});
Object.defineProperty(exports, 'encodeCustomAuthMetadata', {
  enumerable: true,
  get: function () {
    return _AuthMetadata.encodeCustomAuthMetadata;
  },
});
Object.defineProperty(exports, 'decodeSimpleAuthPayload', {
  enumerable: true,
  get: function () {
    return _AuthMetadata.decodeSimpleAuthPayload;
  },
});
Object.defineProperty(exports, 'decodeAuthMetadata', {
  enumerable: true,
  get: function () {
    return _AuthMetadata.decodeAuthMetadata;
  },
});

var _RSocketClient = _interopRequireDefault(require('./RSocketClient'));

var _RSocketServer = _interopRequireDefault(require('./RSocketServer'));

var _RSocketResumableTransport = _interopRequireDefault(
  require('./RSocketResumableTransport')
);

var _WellKnownMimeType = _interopRequireWildcard(
  require('./WellKnownMimeType')
);

var _WellKnownAuthType = _interopRequireWildcard(
  require('./WellKnownAuthType')
);

var _RSocketFrame = require('./RSocketFrame');

var _RSocketBinaryFraming = require('./RSocketBinaryFraming');

var _RSocketBufferUtils = require('./RSocketBufferUtils');

var _RSocketEncoding = require('./RSocketEncoding');

var _RSocketSerialization = require('./RSocketSerialization');

var _RSocketLease = require('./RSocketLease');

var _CompositeMetadata = require('./CompositeMetadata');

var _RoutingMetadata = require('./RoutingMetadata');

var _AuthMetadata = require('./AuthMetadata');
function _getRequireWildcardCache() {
  if (typeof WeakMap !== 'function') return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function () {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || (typeof obj !== 'object' && typeof obj !== 'function')) {
    return {default: obj};
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor =
    Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor
        ? Object.getOwnPropertyDescriptor(obj, key)
        : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {default: obj};
}
